<template>
  <div>
    <h1>{{ $t('where-do-i-vote') }}</h1>
    <p class="lead">{{ $t('find-your-election-day') }}</p>
    <form class="needs-validation" :class="{ 'was-validated': show_error }" novalidate>

      <div class="form-row">
        <div class="col-sm-6">
          <fieldset>
            <legend>{{ $t('home-address') }}</legend>
            <div class="form-group">
              <label for="address">{{ $t( 'select_address' ) }}</label>
              <vue-simple-suggest id="addressSearch" :debounce="500" v-model="address" autocomplete="off" display-attribute="value" value-attribute="id" :list="getAddressList" v-on:select="selectAddress" @change="address_changing" ></vue-simple-suggest>
              <small class="form-text text-muted">
                  {{$t('address_note')}}
              </small>
              <div v-if="show_error" class="feedback">{{ $t('must-select-address') }}</div>
            </div>
          </fieldset>
        </div>
      </div>

      <div class="row no-gutters mb-5">
        <div class="col">
          <button type="button" class="btn btn-primary mt-2" @click="find_locations">{{$t('find-voting-locations')}}</button>
        </div>
      </div>

    </form>

  </div>
</template>

<script>

  import VueSimpleSuggest from "vue-simple-suggest";
  import "vue-simple-suggest/dist/styles.css";

  export default {
    components: { VueSimpleSuggest },
    data() {
      return {
        address: null,
        term: '',
        show_error: false,
        address_id: null,
      }
    },

    methods: {
      getAddressList(query) {
        let url = this.$APP_API_URL + '?action=find-address&term=' + query;
        return fetch(url, { method: 'GET' })
            .then(response => response.json())
            .then(json => json);
      },

      async selectAddress(result) {
        this.address_id = result.id;
      },

      address_changing(address) {
          this.address = {},
          this.show_error = false;
          this.term = address;
      },

      find_locations() {
        if (this.address_id) {
          this.$router.push({ name: "ShowVotingLocations", params: {address_id: this.address_id} });
        } else {
          this.show_error = true; 
        }
      },

    },


  }
</script>

<style>
.feedback {
  color: #CE2334;
}
</style>
